import React, { useContext, useMemo, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { FiHeart, FiSliders, FiX } from "react-icons/fi";
import "../css/shop.scss";
import productData from "../Datas/productData";
import { CartContext } from "./CartContext";
import { formatMoney } from "../siteConfig";

const broadCategories = {
  "Decorative Homeware": ["Art + Prints", "Baskets + Storage", "Cushions + Throws", "Candles + Holders", "Pots + Vases", "Rugs + Textiles"],
  "Kitchen + Dining + Utility Homeware": ["Ceramics", "Kitchen + Dining", "Pantry", "Bath + Body"],
  "Kitchen + Dining": ["Ceramics", "Kitchen + Dining", "Pantry"],
  Lifestyle: ["Books + Events", "Bath + Body", "Pantry", "Baskets + Storage"],
};

function Shop() {
  const [params, setParams] = useSearchParams();
  const [sort, setSort] = useState("featured");
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [maxPrice, setMaxPrice] = useState(180);
  const { wishlist, toggleWishlist } = useContext(CartContext);
  const selectedCategory = params.get("category") || "All products";
  const search = params.get("search") || "";
  const categories = ["All products", ...new Set(productData.map((product) => product.category))];

  const products = useMemo(() => {
    const result = productData.filter((product) => {
      const broadMatch = selectedCategory === "Sale"
        ? Boolean(product.onSale)
        : selectedCategory === "All products"
          ? true
          : broadCategories[selectedCategory]
            ? broadCategories[selectedCategory].includes(product.category)
            : product.category === selectedCategory;
      const text = `${product.name} ${product.tags.join(" ")} ${product.description}`.toLowerCase();
      return broadMatch && product.price <= maxPrice && (!search || text.includes(search.toLowerCase()));
    });
    if (sort === "price-asc") result.sort((a, b) => a.price - b.price);
    if (sort === "price-desc") result.sort((a, b) => b.price - a.price);
    if (sort === "az") result.sort((a, b) => a.name.localeCompare(b.name));
    return result;
  }, [selectedCategory, search, maxPrice, sort]);

  const chooseCategory = (category) => {
    const next = new URLSearchParams(params);
    if (category === "All products") next.delete("category"); else next.set("category", category);
    setParams(next);
  };

  return (
    <main className="shop page-shell">
      <header className="collection-header"><p className="eyebrow">Collection</p><h1>{search ? `Search: “${search}”` : selectedCategory}</h1><p>{products.length} products</p></header>
      <div className="collection-toolbar"><button onClick={() => setFiltersOpen(true)}><FiSliders /> Filter</button><label>Sort by:<select value={sort} onChange={(event) => setSort(event.target.value)}><option value="featured">Featured</option><option value="az">Alphabetically, A–Z</option><option value="price-asc">Price, low to high</option><option value="price-desc">Price, high to low</option></select></label></div>
      <div className="collection-layout">
        <aside className={`filters ${filtersOpen ? "is-open" : ""}`}><button className="filter-close" onClick={() => setFiltersOpen(false)} aria-label="Close filters"><FiX /></button><h2>Filter</h2><div className="filter-block"><h3>Category</h3>{categories.map((category) => <button key={category} className={selectedCategory === category ? "active" : ""} onClick={() => chooseCategory(category)}>{category}</button>)}</div><div className="filter-block"><h3>Price</h3><input type="range" min="45" max="180" value={maxPrice} onChange={(event) => setMaxPrice(Number(event.target.value))} /><p>Up to {formatMoney(maxPrice)}</p></div></aside>
        {products.length ? <div className="product-grid">{products.map((product) => <article className="product-card" key={product.id}><div className="product-card-image"><Link to={`/shopDetails/${product.id}`}><img loading="lazy" src={product.image} alt={product.name} /><img loading="lazy" className="hover-image" src={product.images[1]} alt="" /></Link><button className={wishlist.includes(product.id) ? "saved" : ""} onClick={() => toggleWishlist(product.id)} aria-label={`${wishlist.includes(product.id) ? "Remove" : "Add"} ${product.name} ${wishlist.includes(product.id) ? "from" : "to"} wishlist`}><FiHeart /></button>{!product.stock && <span className="sold-badge">Sold out</span>}</div><Link to={`/shopDetails/${product.id}`}><h2>{product.name}</h2><p>{formatMoney(product.price)}</p></Link></article>)}</div> : <div className="empty-results"><h2>No pieces found</h2><p>Try another category, search term or price limit.</p><button onClick={() => { setParams({}); setMaxPrice(180); }}>Clear filters</button></div>}
      </div>
    </main>
  );
}

export default Shop;
